import { render, staticRenderFns } from "./StringColumnSettings.vue?vue&type=template&id=51ed27fc&scoped=true&"
import script from "./StringColumnSettings.vue?vue&type=script&lang=js&"
export * from "./StringColumnSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed27fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
